import { ArrowLeft } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";
import CheckoutForm from "../../components/shared/checkout-form";
import OrderSummary from "../../components/shared/order-summary";
import ProfileDropdown from "../../components/shared/profileDropdown";
import GlobalContext from "../../context/GlobalContext";
import { useContext } from "react";
import Navbar from "../../components/shared/Navbar";

export default function CheckoutPage() {
  const { userInfo } = useContext(GlobalContext);
  const [searchParams] = useSearchParams();
  const priceId = searchParams.get("price_id");

  const priceMap = {
    price_1AyW5QRmaDbhm5jMTPNoOkF: { plan: "basic", mode: "monthly" },
    price_1RsvHwQRmaDbhm5jx28pqD1w: { plan: "basic", mode: "yearly" },
    price_1RsvEYQRmaDbhm5jCuP4AcCj: { plan: "standard", mode: "monthly" },
    price_1RsvHhQRmaDbhm5jRSkSm5F6: { plan: "standard", mode: "yearly" },
    price_1RsvEoQRmaDbhm5j3LnFYtv4: { plan: "plus", mode: "monthly" },
    price_1RsvGsQRmaDbhm5jPRA948qa: { plan: "plus", mode: "yearly" },
    price_1RsvFPQRmaDbhm5jr2oAe6DJ: { plan: "pro", mode: "monthly" },
    price_1RsvFlQRmaDbhm5jBUOlMeEv: { plan: "pro", mode: "yearly" },
  };

  const { plan: selectedPlan, mode: billingMode } = priceMap[priceId] || {
    plan: "basic",
    mode: "monthly",
  };

  return (
    <div className="bg-white min-h-screen">
      <Navbar />

      <main className="mx-auto px-4 py-8 container">
        <div className="mx-auto max-w-6xl">
          <Link
            to="/membership"
            className="inline-flex items-center mb-6 text-green-600 hover:text-green-700"
          >
            <ArrowLeft className="mr-2 w-4 h-4" />
            Back to plans
          </Link>

          <h2 className="mb-8 font-bold text-green-600 text-3xl text-center">
            Complete Your Purchase
          </h2>

          <div className="gap-8 grid md:grid-cols-5">
            {/* Checkout form */}
            <div className="md:col-span-3">
              <CheckoutForm
                selectedPlan={selectedPlan}
                billingMode={billingMode}
                priceId={priceId}
              />
            </div>

            {/* Order summary */}
            <div className="md:col-span-2">
              <OrderSummary
                selectedPlan={selectedPlan}
                billingMode={billingMode}
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
